<app-reactive-dialog-content [data]="dialogInputData">

  <app-basic-datepicker label="Beginndatum" [fieldProperty]="beratungChange.beginndatum"
                        [formControl]="getFormControl('beginndatum')"></app-basic-datepicker>
  <app-basic-datepicker label="Ablaufdatum" [fieldProperty]="beratungChange.ablaufdatum"
                        [formControl]="getFormControl('ablaufdatum')"></app-basic-datepicker>

  <app-basic-input label="Versicherungsbestätigung" [fieldProperty]="beratungChange.versicherungsbestaetigung"
                   [formControl]="getFormControl('versicherungsbestaetigung')"></app-basic-input>

  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span>Inkasso</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <!-- inkasso component doesnt support reactive forms for now -->
    <app-inkasso [(ngModel)]="inkasso" [polizzeId]="polizzeId" [vkeId]="vkeId" [currentKundeID]="ersterKundeId"
                 [saveDirectly]="false"></app-inkasso>
  </mat-expansion-panel>

  <div class="button-container-right">
    <button mat-raised-button color="accent" class="button-right-margin" (click)="onSaveClick()">SPEICHERN</button>
    <button mat-raised-button class="mat-gray-bg" (click)="onCancelClick()">ABBRECHEN</button>
  </div>
</app-reactive-dialog-content>
